import React from "react";

export const NoImage = ({ size = 64 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1590_65889)">
      <path
        d="M63.9939 0.00195312H0.00195312V63.9939H63.9939V0.00195312Z"
        fill="url(#paint0_linear_1590_65889)"
      />
      <path
        d="M59.3912 4.59766H4.61523V59.3736H59.3912V4.59766Z"
        fill="#FAFBFC"
      />
      <path
        d="M11.3633 45.531L23.8806 33.0137L36.3846 45.5283H11.3633V45.531Z"
        fill="#253858"
      />
      <path
        d="M20.1484 45.5257L36.3884 29.291L52.6311 45.5257H20.1511H20.1484Z"
        fill="#0065FF"
      />
      <path
        d="M24.8534 23.0752C26.72 22.0938 27.4374 19.7818 26.456 17.9152C25.4747 16.0485 23.1627 15.3312 21.296 16.3125C19.4294 17.2938 18.712 19.6032 19.6934 21.4725C20.6747 23.3392 22.9867 24.0565 24.8534 23.0752Z"
        fill="#FFAB00"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1590_65889"
        x1="0.00461953"
        y1="63.994"
        x2="63.9966"
        y2="0.00195339"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.39" stopColor="#C1C7D0" />
        <stop offset="0.71" stopColor="#C3C9D1" stopOpacity="0.74" />
        <stop offset="0.82" stopColor="#CACFD7" stopOpacity="0.64" />
        <stop offset="0.91" stopColor="#D5DAE0" stopOpacity="0.58" />
        <stop offset="0.97" stopColor="#E6E9ED" stopOpacity="0.52" />
        <stop offset="1" stopColor="#F0F2F5" stopOpacity="0.5" />
      </linearGradient>
      <clipPath id="clip0_1590_65889">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
